import { CheckCircle2, Circle, Info, Loader2 } from "lucide-react";
import React from "react";

const steps = [
	{ label: "Initializing", status: "done" },
	{ label: "Checking Education", status: "done" },
	{ label: "Checking Experience", status: "done" },
	{ label: "Checking Certifications", status: "done" },
	{ label: "Reviewing Key Skills", status: "done" },
	{ label: "Spotting Your Strengths", status: "loading" },
	{ label: "Highlighting Focus Areas", status: "pending" },
	{ label: "Preparing Guidance", status: "pending" },
	{ label: "Preparing Insights", status: "pending" },
];

const progress = 54;

function FitCheckLoading() {
	return (
		<div className="max-w-2xl mx-auto p-8">
			<h2 className="text-xl font-bold text-gray-900 mb-1">Analyzing Your Fit...</h2>
			<p className="text-gray-700 mb-6">
				We&apos;re reviewing your resume against this job to highlight your strengths, gaps, and focus areas.
			</p>

			{/* Progress Bar */}
			<div className="flex items-center gap-3 mb-6">
				<div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
					<div className="h-2 bg-blue-600 rounded-full transition-all" style={{ width: `${progress}%` }} />
				</div>
				<span className="text-sm font-medium text-gray-700 min-w-[40px]">{progress}%</span>
			</div>

			<div className="mb-4">
				<h3 className="text-base font-semibold text-gray-900 mb-1">Analysis Steps</h3>
				<p className="text-gray-600 text-sm mb-4">Hang tight! This won&apos;t take long...</p>

				<div className="grid grid-cols-2 sm:grid-cols-3 gap-y-3 gap-x-4">
					{steps.map((step) => (
						<div key={step.label} className="flex items-center gap-2">
							{step.status === "done" && <CheckCircle2 className="w-5 h-5 text-green-600" />}
							{step.status === "loading" && <Loader2 className="w-5 h-5 text-blue-500 animate-spin" />}
							{step.status === "pending" && <Circle className="w-5 h-5 text-gray-300" />}
							<span
								className={
									step.status === "done"
										? "text-gray-800"
										: step.status === "loading"
											? "text-blue-700"
											: "text-gray-400"
								}
							>
								{step.label}
							</span>
						</div>
					))}
				</div>
			</div>

			<div className="mt-8 bg-blue-50 rounded-lg px-4 py-3 flex items-center gap-3">
				<Info className="w-5 h-5 text-blue-500" />
				<span className="text-sm text-blue-900">
					<span className="font-semibold">Pro Tip:</span> Your FitCheck results will be saved to your dashboard for
					future reference!
				</span>
			</div>
		</div>
	);
}

export default FitCheckLoading;
